import MasonrySdk from '@wix/thunderbolt-elements/src/components/Masonry/corvid/Masonry.corvid';


const Masonry = {
  sdk: MasonrySdk
};


export const components = {
  ['Masonry']: Masonry
};

